import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { HomePageService } from 'src/app/Services/home-page.service';
import { MetaService } from 'src/app/Services/meta-data.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-category-view',
  templateUrl: './category-view.component.html',
  styleUrls: ['./category-view.component.scss']
})
export class CategoryViewComponent implements OnInit {
  currentLink:any
 public config: SwiperConfigInterface = {};
    brandsList: any;
    CateSwiperConfig: any = {};
    environmentVariables: any;
    lang: any;
    routerSubscription: any;
    allCategories: any[] = [];
    arrayList: any[] = [];
    loading: boolean = true;
    headerName: any;
    selectedCategory: any;
    selectedGroup: any;
    fakeArray = new Array(8);
    firstTimeLoaded = true;
    categoriesPage = false;
    showbreadCrumb = false
    allFeaturedCategories:any = [];
    nameRouting: any = [];
    // customCategoriesOptions!: OwlOptions;
    @Input() isSlider : any =  null;
      categoryTypeData = {
       isSlider:'',
       isSqure:'',
    };

    currentPageView:any = ''
    currentPageViewUrl : any
    currentSubCategoryPageViewUrl : any
  constructor(

      public embryoService: EmbryoService,
        private translate: TranslateService,
        private router: Router,
        public route: ActivatedRoute,
        private homeData: HomePageService,
        private confgServ: StaticPagesService,
        private cdRef: ChangeDetectorRef,
        private metaService: MetaService,

  ) { 

        this.getInitilizingData();
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
            if (!this.firstTimeLoaded) {
                this.getCategories();
            }
        });

        this.routerSubscription = router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.getCategories();
                this.currentLink = this.router.url;
            }
        });
        if(window.location.href.includes("categories")){
          this.categoriesPage=true;
        }
        else{ 
            this.categoriesPage=false;
        }
    }
  ngAfterViewInit() {
    this.nameRouting.push({name_en: 'categories', name_ar: 'الفئات'})
    this.cdRef.detectChanges();
              this.homeData.categoriesDataSub.subscribe((data) => {
              if(data.length > 0){
                  this.allCategories = data ;
                  this.getCategories();
          }
        });
     this.cdRef.detectChanges();

   
        this.CateSwiperConfig = {
            slidesPerView: 7,
            spaceBetween: 16,
              keyboard: true,
            navigation: true,
            pagination: false,
            grabCursor: true,
            loop: true,
            preloadImages: false,
            lazy: true,
            rtl:true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            speed: 500,
            effect: "slide",
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                480: {
                    slidesPerView: 2,
                },
                600: {
                    slidesPerView: 3,
                },
                960: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 6,
                },
                1280: {
                    slidesPerView: 6,
                },
                1500: {
                    slidesPerView: 6,
                },
            },
        };
    





     
      
    }
  
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.categoryTypeData.isSlider = this.environmentVariables.CATEGORY_STYLE;
            this.categoryTypeData.isSqure = this.environmentVariables.CATEGORY_CARD;
            // console.log(this.categoryTypeData);
            
        });
    }


    rediectToProductPage(item:any){
      console.log(item);
      
      this.router.navigate(["/" + this.lang + (this.environmentVariables?.ENABLE_CATEGORY_VIEW ? "/category": "/products")], {
                    queryParams: {
                        category_id: item.id,
                    },
                });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.firstTimeLoaded = false;
        }, 1000);

        
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }

    getCategories() {
      // console.log("is slider => ",this.isSlider);
      
        var lang = this.lang;
        if (this.allCategories.length) {
            this.loading = false;
            let selectedCategory = [];
            let selectedGroup = [];
            const segments = this.router.url.split('/');
               if(this.route.snapshot.queryParams["category_id"] 
                 || (this.environmentVariables.MENU_LINK_TYPE === 'slug' && segments[3]?.length > 0 )){
              // this.currentPageViewUrl = `v2/groups-by-categories/${this.environmentVariables.MENU_LINK_TYPE === 'slug' ?  segments[3] : this.route.snapshot.queryParams["category_id"]}`;
              this.currentPageViewUrl = `v2/groups-by-categories/${
                this.route.snapshot.queryParams["category_id"] ? this.route.snapshot.queryParams["category_id"] : segments[3]}`;
              this.currentSubCategoryPageViewUrl = '';
            }
            if (
                (this.route.snapshot.queryParams["category_id"] &&
                this.route.snapshot.queryParams["group_id"]) || 
                (this.environmentVariables.MENU_LINK_TYPE === 'slug' && segments[3]?.length > 0 && segments[4]?.length > 0)
            ) {
              this.currentSubCategoryPageViewUrl = 
              // `v2/categories/${this.environmentVariables.MENU_LINK_TYPE === 'slug' ?  segments[4] : this.route.snapshot.queryParams["group_id"]}/subcategories`;
              `v2/categories/${this.route.snapshot.queryParams["group_id"] ? this.route.snapshot.queryParams["group_id"]: segments[4]}/subcategories`;

              this.currentPageViewUrl = '';
                selectedCategory = this.selectedCategory =
                    this.allCategories.filter((category) => {
                        return (
                          !this.route.snapshot.queryParams["category_id"] ? 
                           category.slug === segments[3] 
                           :
                         category.id ===   parseInt(
                                this.route.snapshot.queryParams["category_id"]
                            )
                        );
                    });

                selectedGroup = this.selectedGroup =
                    this.selectedCategory[0]?.groups.filter((group: any) => {
                        return (
                           !this.route.snapshot.queryParams["group_id"] ? 
                            group.slug === segments[4]
                            :
                         group.id ===    parseInt(
                                this.route.snapshot.queryParams["group_id"]
                            )
                        );
                    });

                this.headerName = selectedGroup[0];
                this.arrayList = selectedGroup[0]?.sub_categories.map(
                    (subCategories: any) => {
                        return {
                            itemName:
                                lang == "ar" && subCategories.name_ar
                                    ? subCategories.name_ar
                                    : subCategories.name,
                            itemId: subCategories.id,
                            itemImage: subCategories.image,
                            groupSlug:this.selectedGroup[0]?.slug,
                            link: subCategories.slug,
                            itemType: "group",
                        };
                    }
                );
            } else if (
                ((this.route.snapshot.queryParams["category_id"] || (segments[3]?.length > 0 && this.environmentVariables.MENU_LINK_TYPE === 'slug') ) &&
                !this.route.snapshot.queryParams["group_id"] || (segments[4]?.length == 0 && this.environmentVariables.MENU_LINK_TYPE === 'slug') )
            ) {
              // console.log(this.selectedCategory);

                selectedCategory = this.selectedCategory =
                    this.allCategories.filter((category) => {
                        return (
                              !this.route.snapshot.queryParams["category_id"] ? 
                            category.slug === segments[3]
                            :
                           category.id ===  parseInt(
                                this.route.snapshot.queryParams["category_id"]
                            )
                        );
                    });

                this.headerName = selectedCategory[0];
                setTimeout(() => {
                     if(this.lang == 'en'){
                   this.metaService.setTitle(
                          ` ${this.headerName?.name_en} |  ${this.environmentVariables?.META_TITLE_EN ? this. environmentVariables?.META_TITLE_EN :  this.environmentVariables?.APP_NAME} `
                      );
                    document.getElementById('MetaDescription')?.setAttribute('content' ,
                     `${this.headerName?.name_en} | ${this.environmentVariables?.metaDescriptionEn ? this. environmentVariables?.metaDescriptionEn : 
                      `Shop for it at ${this.environmentVariables?.APP_NAME}.Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy it online from ${this.environmentVariables?.APP_NAME}`}`
                )
                }else{
                     this.metaService.setTitle(
                       ` ${this.headerName?.name_ar} |  ${this.environmentVariables?.META_TITLE_AR ? this. environmentVariables?.META_TITLE_AR :  this.environmentVariables?. APP_NAME} `
                     );
                        document.getElementById('MetaDescription')?.setAttribute('content' ,
                  `${this.headerName?.name_ar} | ${this.environmentVariables?.metaDescriptionAr ? this. environmentVariables?.metaDescriptionAr : 
                    `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.APP_NAME}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.APP_NAME}`}`
                  )
                }
                }, 1000);
             
                
         
                this.arrayList = selectedCategory[0]?.groups.map(
                    (group: any) => {
                      // console.log(group);
                        return {
                            itemName:
                                lang == "ar" && group.name_ar
                                    ? group.name_ar
                                    : group.name,
                            itemId: group.id,
                            itemImage: group.image,
                            itemType: "category",
                            sub_categories:group.sub_categories,
                            categorySlug:this.selectedCategory[0]?.slug,
                            link:group?.slug ?? "general"
                        };
                    }
                );

                let selectedCategoryMeta = selectedCategory[0]
                this.metaService.updateTag({
                  property: "og:title",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_title_en
                          : selectedCategoryMeta?.meta_tag_title_ar,
              });
                this.metaService.updateTag({
                  name: "og:title",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_title_en
                          : selectedCategoryMeta?.meta_tag_title_ar,
              });
              this.metaService.updateTag({
                  property: "og:description",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_description_en
                          : selectedCategoryMeta?.meta_tag_description_ar,
              });
              this.metaService.updateTag({
                  name: "og:description",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_description_en
                          : selectedCategoryMeta?.meta_tag_description_ar,
              });
              setTimeout(() => {
                this.metaService.updateTag({
                  property: "keywords",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_keywords_en
                          : selectedCategoryMeta?.meta_tag_keywords_en,
              });
                this.metaService.updateTag({
                  name: "keywords",
                  content:
                      this.lang == "en"
                          ? selectedCategoryMeta?.meta_tag_keywords_en
                          : selectedCategoryMeta?.meta_tag_keywords_en,
              });
              
              document
              .getElementById("keywordsMeta")
              ?.setAttribute(
                  "content",
                  this.lang == "en"
                      ? selectedCategoryMeta?.meta_tag_keywords_en
                      : selectedCategoryMeta?.meta_tag_keywords_ar
              );
              }, 1000);             
            }
            else {
              this.allFeaturedCategories = this.allCategories;
              if(!this.isSlider){
              this.categoriesPage = true;
              this.showbreadCrumb=true;
              }else{
                this.categoriesPage = false;
                this.showbreadCrumb = false;
              }
              

            }
        }

        if(this.isSlider == undefined){
          this.allFeaturedCategories = this.allCategories;
          this.categoryTypeData.isSlider = 'grid'
        }else{
            this.allFeaturedCategories = this.allCategories.filter(x=>x.featured);
            if(this.environmentVariables.CATEGORY_STYLE == 'slider'){
                this.categoryTypeData.isSlider = 'slider'
            }
        }

            
    }

  viewAllCategories(){
    let segements = this.router.url.split('/');
    if(this.environmentVariables?.MENU_LINK_TYPE === 'slug'){
      let url = `/${this.lang}/product/${segements[3]}`;
      if (segements[4]) {
        url += `/${segements[4]}`;
      }
      this.router.navigate([url]);
    }
    else{
      this.router.navigate(["/" + this.lang + "/products"], {
        queryParams: {
          category_id: this.selectedCategory[0]?.id
        }
      })
    }
  }

  viewAllGroups(item:any){
   this.router.navigate(["/" + this.lang + "/products"], {
       queryParams: {
           category_id: this.selectedCategory[0]?.id,
               category_name:
                this.lang == "ar" &&
                this.selectedCategory[0]?.name_ar
                ? this.selectedCategory[0]?.name_ar
                : this.selectedCategory[0]?.name,
                group_id: item.itemId,
           }
        })
  }

  viewSubCategory(sub:any , groub?:any){
    console.log(groub);
    if(this.environmentVariables?.MENU_LINK_TYPE === 'slug'){
            const newPath = this.router.url.replace('/category/', '/product/');
            if(groub){
              this.router.navigateByUrl(`${newPath}/${groub?.link}/${sub?.slug}`);
            }else{
              this.router.navigateByUrl(`${newPath}/${sub?.link}`);

            }
    }else{
       this.router.navigate(["/" + this.lang + "/products"],{
       queryParams:{
                category_id: this.selectedCategory[0]?.id,
                category_name:
                 this.lang == 'ar' &&
                 this.selectedCategory[0].name_ar
                 ? this.selectedCategory[0].name_ar
                 : this.selectedCategory[0].name,
                 sub_category_id: sub?.itemId,
                 group_id:sub?.itemId,
                 sub_category_name :this.lang == 'ar' && sub?.name_ar
                             ? sub?.name_ar
                             : sub?.name,
                             page:1
              }           
            }
    )}
  }



 routeToGroup(item:any) {
   if(this.environmentVariables?.MENU_LINK_TYPE === 'slug'){
           if(this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW){
                this.router.navigate([this.lang + "/category/" + item?.categorySlug + '/' + item?.link])
              }else{
                  this.router.navigate([this.lang + '/product/' + item?.categorySlug + '/' + item?.link]);
              }
            }else{

        if(this.environmentVariables?.ENABLE_SUBCATEGORY_VIEW){
                this.router.navigate([this.lang + "/category/" + 'products'],{
                  queryParams:{
                      category_id: this.selectedCategory[0]?.id,
                      category_name:
                          this.lang == 'ar' &&
                          this.selectedCategory[0]?.name_ar
                              ? this.selectedCategory[0]?.name_ar
                              : this.selectedCategory[0]?.name,
                      group_id: item.itemId,
                      group_name: item.itemName
                    }
                  }
                )
              }else{
              this.router.navigate([this.lang + "/products/"],{
                  queryParams:{
                      category_id: this.selectedCategory[0]?.id,
                        group_id: item.itemId
                    }
                  }
                )
              }
            }
  }
}


